import React, { useState } from 'react';
import { image } from "../common/Theme";
import {
    Badge, Table, TableBody, Modal, TableCell, Typography, Box, Button, Drawer, IconButton, List, ListItem, ListItemText, useMediaQuery, useTheme, CircularProgress
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Apiconnection from '../utils/Apiconnection';
import { useNavigate } from 'react-router-dom';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useNotifications } from '../context/NotificationContext';
export function Header() {


    const [openCheckInModal, setOpenCheckInModal] = useState(false);
    const [policies, setPolicies] = useState('');
    const [loading, setLoading] = useState(false);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { unreadCount, fetchNotifications, markAllNotificationsRead } = useNotifications();

    const navigate = useNavigate();

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setIsDrawerOpen(open);
    };

    const handleTermsConditions = async () => {
        setOpenCheckInModal(true);
        setLoading(true);
        try {
            const response = await Apiconnection.post('content-page-get-by-type', {
                type: 'terms_and_conditions'
            });
            if (response?.data?.status && (response?.data?.data?.description || response?.data?.data?.policies)) {
                const fetchedPolicies = response.data.data.description || response.data.data.policies || '';
                const cleanPolicies = fetchedPolicies.replace(/<h2>Policies<\/h2>/i, '');
                setPolicies(cleanPolicies);
            } else {
                const fallbackResponse = await Apiconnection.post('get-policies');
                if (fallbackResponse?.data?.status) {
                    const fallbackPolicies = fallbackResponse?.data?.data?.policies || '';
                    const cleanPolicies = fallbackPolicies.replace(/<h2>Policies<\/h2>/i, '');
                    setPolicies(cleanPolicies);
                }
            }
        } catch (error) {
            console.error('Error fetching terms & conditions:', error);
            try {
                const fallbackResponse = await Apiconnection.post('get-policies');
                if (fallbackResponse?.data?.status) {
                    const fallbackPolicies = fallbackResponse?.data?.data?.policies || '';
                    const cleanPolicies = fallbackPolicies.replace(/<h2>Policies<\/h2>/i, '');
                    setPolicies(cleanPolicies);
                }
            } catch (err) {
                console.error('Error fetching fallback policies:', err);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        setIsLogoutModalOpen(true);
    };

    const handleNotificationClick = async () => {
        await fetchNotifications(1, 10);
        await markAllNotificationsRead();
        navigate('/notification-list');
    };

    const confirmLogout = () => {
        localStorage.removeItem('prime_access_token');
        localStorage.removeItem('userInfo');
        navigate('/login');
        window.location.reload();
    };

    const tokenExists = !!localStorage.getItem('prime_access_token');

    const CustomerInfo = JSON.parse(localStorage.getItem('userInfo'));

    const userInfo = {
        email: CustomerInfo?.email,
        password: CustomerInfo?.password,
        customerId: CustomerInfo?.id,
        firstName: CustomerInfo?.firstName,
        lastName: CustomerInfo?.lastName,
        phone: CustomerInfo?.phone
    };

    // console.log('UserInfo',userInfo?.id)

    return (

        <div className="nav-top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 40px', backgroundColor: 'transparent' }}>
            <div className="nav-logo" style={{ backgroundColor: '#fff', padding: '10px 25px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                <img src={image.logo} alt="" style={{ height: '80px' }} />
            </div>

            {isMobile ? (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {tokenExists && (
                            <IconButton
                                aria-label="open notifications"
                                onClick={handleNotificationClick}
                                sx={{
                                    color: 'white',
                                    border: '1px solid rgba(255,255,255,0.35)',
                                    width: 42,
                                    height: 42,
                                }}
                            >
                                <Badge badgeContent={unreadCount} color="error" max={99}>
                                    <NotificationsNoneOutlinedIcon />
                                </Badge>
                            </IconButton>
                        )}
                        <IconButton 
                            edge="start" 
                            color="inherit" 
                            aria-label="menu" 
                            onClick={toggleDrawer(true)}
                            sx={{ color: 'white' }}
                        >
                            <MenuIcon fontSize="large" />
                        </IconButton>
                    </Box>
                    <Drawer
                        anchor="right"
                        open={isDrawerOpen}
                        onClose={toggleDrawer(false)}
                        PaperProps={{
                            sx: { width: '250px', backgroundColor: '#004777', color: 'white' }
                        }}
                    >
                        <Box
                            sx={{ width: 250 }}
                            role="presentation"
                            onClick={toggleDrawer(false)}
                            onKeyDown={toggleDrawer(false)}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                                <IconButton onClick={toggleDrawer(false)} sx={{ color: 'white' }}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            <List>
                                <ListItem button onClick={() => navigate(tokenExists ? '/booking-list' : -1, { state: userInfo })}>
                                    <ListItemText primary={tokenExists ? 'Booking List' : 'Go Back'} sx={{ '& span': { fontFamily: "'Inter', 'Poppins', sans-serif", fontWeight: 600 } }} />
                                </ListItem>
                                <ListItem button onClick={() => handleTermsConditions()}>
                                    <ListItemText primary="Terms & Conditions" sx={{ '& span': { fontFamily: "'Inter', 'Poppins', sans-serif", fontWeight: 600 } }} />
                                </ListItem>
                                {tokenExists && (
                                    <ListItem button onClick={handleNotificationClick}>
                                        <ListItemText primary={`Notifications${unreadCount ? ` (${unreadCount})` : ''}`} sx={{ '& span': { fontFamily: "'Inter', 'Poppins', sans-serif", fontWeight: 600 } }} />
                                    </ListItem>
                                )}
                                {tokenExists && (
                                    <ListItem button onClick={handleLogout}>
                                        <ListItemText primary="Logout" sx={{ '& span': { fontFamily: "'Inter', 'Poppins', sans-serif", fontWeight: 600 } }} />
                                    </ListItem>
                                )}
                            </List>
                        </Box>
                    </Drawer>
                </>
            ) : (
                <div className="nav-link" style={{ gap: '30px', display: 'flex', alignItems: 'center' }}>
                    <div onClick={() => navigate(tokenExists ? '/booking-list' : -1, { state: userInfo })} style={{ color: 'white', cursor: 'pointer', margin: 0, fontWeight: 600, fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px', borderBottom: '2px solid white', paddingBottom: '5px' }}>
                        <FormatListBulletedIcon fontSize="small" /> {tokenExists ? 'Booking List' : 'Go Back'}
                    </div> 

                    <div onClick={() => handleTermsConditions()} style={{ color: 'white', cursor: 'pointer', margin: 0, fontWeight: 500, fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px' }} >
                        <DescriptionOutlinedIcon fontSize="small" /> Terms &amp; Conditions
                    </div> 
                    {tokenExists && ( 
                        <>
                            <IconButton
                                aria-label="open notifications"
                                onClick={handleNotificationClick}
                                sx={{
                                    color: 'white',
                                    border: '1px solid rgba(255,255,255,0.35)',
                                    width: 42,
                                    height: 42,
                                    '&:hover': {
                                        backgroundColor: 'rgba(255,255,255,0.12)',
                                    }
                                }}
                            >
                                <Badge badgeContent={unreadCount} color="error" max={99}>
                                    <NotificationsNoneOutlinedIcon />
                                </Badge>
                            </IconButton>
                            <span style={{ color: 'rgba(255,255,255,0.5)' }}>|</span>
                            <div onClick={handleLogout} style={{ color: 'white', cursor: 'pointer', margin: 0, fontWeight: 500, fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <LogoutOutlinedIcon fontSize="small" /> Logout
                            </div>
                        </>
                    )}
                </div>
            )}

            <Modal
                open={openCheckInModal}
                onClose={() => setOpenCheckInModal(false)}
                aria-labelledby="terms-conditions-modal"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#ffffff',
                    padding: { xs: '30px 20px', sm: '40px 30px' },
                    borderRadius: '24px',
                    width: '90%',
                    maxWidth: '600px',
                    boxShadow: '0 25px 80px rgba(0,0,0,0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '85vh',
                }}>
                    <Box sx={{ borderBottom: '1px solid #f0f0f0', pb: 2, mb: 3 }}>
                        <Typography variant="h5" sx={{ fontFamily: "'Inter', 'Poppins', sans-serif", fontWeight: 800, color: '#1a1a1a', textAlign: 'center' }}>
                            Terms &amp; Conditions
                        </Typography>
                    </Box>
                    
                    <Box sx={{
                        flex: 1,
                        overflowY: 'auto',
                        pr: 2,
                        '&::-webkit-scrollbar': { width: '6px' },
                        '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '10px' },
                        '&::-webkit-scrollbar-thumb': { background: '#c1c1c1', borderRadius: '10px' },
                        '&::-webkit-scrollbar-thumb:hover': { background: '#a8a8a8' },
                        color: '#4a5568',
                        fontFamily: "'Inter', 'Poppins', sans-serif",
                        fontSize: '14px',
                        lineHeight: 1.6,
                        '& ul': { paddingLeft: '22px', mb: 2 },
                        '& li': { mb: 1.2 },
                        '& strong': { color: '#0f172a' },
                        '& p': { mb: 1.5 },
                        '& h1, & h2, & h3': { color: '#0f172a', mb: 1.5, fontWeight: 700 }
                    }}>
                        {loading && !policies ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
                                <CircularProgress size={32} sx={{ color: '#004777' }} />
                            </Box>
                        ) : (
                            <div id="check-in-modal-description" dangerouslySetInnerHTML={{ __html: policies }} />
                        )}
                    </Box>

                    <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'center' }}>
                        <Button 
                            variant="contained" 
                            onClick={() => setOpenCheckInModal(false)}
                            sx={{ 
                                fontFamily: "'Inter', 'Poppins', sans-serif", 
                                backgroundColor: '#004777', 
                                borderRadius: '100px', 
                                py: 1.5, 
                                px: 5,
                                fontWeight: 700, 
                                textTransform: 'none', 
                                fontSize: '16px', 
                                boxShadow: '0 8px 20px rgba(0, 71, 119, 0.2)', 
                                '&:hover': { backgroundColor: '#003355', boxShadow: '0 10px 25px rgba(0, 71, 119, 0.3)' } 
                            }}
                        >
                            I Understand
                        </Button>
                    </Box>
                </Box>
            </Modal>

            {/* Logout Modal */}
            <Modal
                open={isLogoutModalOpen}
                onClose={() => setIsLogoutModalOpen(false)}
            >
                <Box sx={{ 
                    position: 'absolute', 
                    top: '50%', 
                    left: '50%', 
                    transform: 'translate(-50%, -50%)', 
                    backgroundColor: 'white', 
                    padding: '40px 30px', 
                    borderRadius: '24px',
                    width: '90%',
                    maxWidth: '400px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                    textAlign: 'center',
                    fontFamily: "'Inter', 'Poppins', sans-serif"
                }}>
                    <Typography variant="h5" sx={{ fontFamily: "'Inter', 'Poppins', sans-serif", fontWeight: 800, color: '#1a1a1a', mb: 2 }}>Logout</Typography>
                    <Typography variant="body1" sx={{ fontFamily: "'Inter', 'Poppins', sans-serif", color: '#64748b', mb: 4, fontWeight: 500 }}>Are you sure you want to logout?</Typography>
                    <Box display="flex" gap={2} justifyContent="center">
                        <Button 
                            variant="outlined" 
                            onClick={() => setIsLogoutModalOpen(false)}
                            sx={{ fontFamily: "'Inter', 'Poppins', sans-serif", borderColor: '#004777', color: '#004777', borderRadius: '100px', py: 1.5, fontWeight: 700, flex: 1, borderWidth: '2px', textTransform: 'none', fontSize: '16px', '&:hover': { borderWidth: '2px' } }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="contained" 
                            onClick={confirmLogout}
                            sx={{ fontFamily: "'Inter', 'Poppins', sans-serif", backgroundColor: '#ff4d4f', borderRadius: '100px', py: 1.5, fontWeight: 700, flex: 1, textTransform: 'none', fontSize: '16px', boxShadow: 'none', '&:hover': { backgroundColor: '#d9363e', boxShadow: 'none' } }}
                        >
                            Logout
                        </Button>
                    </Box>
                </Box>
            </Modal>

        </div>

    );
}

export default Header;
